<template>
  <div :class="elementClass" @click="click">
    <svg ref="svg" v-if="d" :style="sizeBox" viewBox="0 0 24 24">
      <path :fill="fill" :d="d" />
    </svg>
  </div>
</template>

<script>
import { iconClass } from "../prefix";
const Data = import("@mdi/js");

export default {
  props: {
    name: {
      default: "",
    },
    size: {
      default: "medium",
    },
  },
  data() {
    return {
      d: null,
      fill: "",
      Data: null,
    };
  },
  computed: {
    elementClass() {
      return iconClass + " mdi material-icons";
    },
    sizeBox() {
      if (this.size === "large") return "width:28px;height:28px";
      else if (this.size === "small") return "width:20px;height:20px";
      else if (this.size === "xsmall") return "width:16px;height:16px";
      return "width:24px;height:24px";
    },
  },
  methods: {
    click() {
      this.$emit("click", this.$el);
    },
  },
  mounted() {
    this.$nextTick(() => {
      Data.then(data => {
        this.Data = data;
        this.fill = window.getComputedStyle(this.$el).getPropertyValue("color");
        this.d = this.Data[this.name];
      });

      setInterval(() => {
        this.fill = window.getComputedStyle(this.$el).getPropertyValue("color");
      }, 100);
    });
  },
  watch: {
    name(val) {
      this.d = this.Data[`mdi${val.charAt(0).toUpperCase()}`];
    },
  },
};
</script>
